import { Component, HostListener, OnDestroy, OnInit, Renderer2, RendererFactory2, ViewChild, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, Meta, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AuthHelperService } from 'app/auth/helpers/auth-helper.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subject, Subscription, delay, lastValueFrom, of, take, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { TranslocoService } from '@jsverse/transloco';
import { AuthenticationService } from 'app/auth/service';
import { DomHelperService } from 'app/global/dom-helper.service';
import { fieldsValidation } from 'app/global/fieldvalidation';
import { setRecipientData } from 'app/global/get-recipient-data';
import { GlobalService } from 'app/global/global.service';
import { RefreshImageService } from 'app/global/refresh-image.service';
import { DeletedAttachment } from 'app/main/pages/events/editor-emitter.dto';
import { EditorEmitterService } from 'app/main/pages/events/editor-emitter.service';
import { SharedStoreFacade } from 'app/main/shared/shared/store/shared-store.facade';
import { TranslationsHelperService } from 'translations.helper.service';
import { DocumentKeyComponent } from '../document-key/document-key.component';
import { AuthenticationTypeEnum, SigningStatusEnum } from '../enums/enum';
import { RefreshFileService } from '../helpers/refresh-file.service';
import { SignDocumentModalComponent } from '../sign-document-modal/sign-document-modal.component';
import { SigningHelperService } from './signing-page-helper';
import { SingingPageService } from './signing-page-service';
import { RoleDetail } from './signing-page.dto';
import { Title } from '@angular/platform-browser';
import { SigningPageEventService } from './signing-page-event.service';
import { RequestPostponedComponent } from '../request-postponed/request-postponed.component';
import { AbstractSigningPageComponent } from './abstract-signing-page.component';
import { HideUnusedBlocksService } from 'app/global/hide-unused-blocks.service';
import { TemplateType } from 'app/main/pages/templates/template.dto';
import { SamsungBrowserInstructionsModalComponent } from 'app/main/pages/general-modals/samsung-browser-instructions-modal/samsung-browser-instructions-modal.component';
@Component({
  selector: 'app-signing-page',
  templateUrl: './signing-page.component.html',
  styleUrls: ['./signing-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class SigningPageComponent extends AbstractSigningPageComponent implements OnInit, OnDestroy {

  /**
   * @param route
   * @param sanitizer
   * @param modalService
   * @param _coreSidebarService
   * @param deviceService
   * @param meta
   * @param authHelper
   * @param singingPage
   * @param globalService
   * @param rendererFactory
   * @param domHelperService
   * @param signingHelperService
   * @param _translocoService
   * @param authenticationService
   * @param _translationsHelperService
   * @param _refreshFileService
   * @param _sharedStoreFacade$
   * @param refreshImageService
   * @param editorEmitter
   */
  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    protected modalService: NgbModal,
    private _coreSidebarService: CoreSidebarService,
    private deviceService: DeviceDetectorService,
    private readonly meta: Meta,
    private authHelper: AuthHelperService,
    protected singingPage: SingingPageService,
    protected globalService: GlobalService,
    rendererFactory: RendererFactory2,
    private domHelperService: DomHelperService,
    private signingHelperService: SigningHelperService,
    private _translocoService: TranslocoService,
    private authenticationService: AuthenticationService,
    private _translationsHelperService:TranslationsHelperService,
    private _refreshFileService: RefreshFileService,
    private _sharedStoreFacade$: SharedStoreFacade,
    private refreshImageService: RefreshImageService,
    private editorEmitter: EditorEmitterService,
    private titleService: Title,
    private signingPageEvent: SigningPageEventService,
    private hideUnusedBlocksService: HideUnusedBlocksService
  ) {
    super(singingPage, globalService, modalService);
    this.renderer = rendererFactory.createRenderer(null, null);
    this.authHelper.setLayoutConfig(true, false, false);
  }
  private renderer: Renderer2;
  public signingDocFlowOne: boolean = true;
  public signingDocFlowTwo: boolean = false;
  public roleId: string;
  public timeOutSubscription: Subscription;
  public loadingSigningArea: boolean = true;
  public iAgreed: boolean = false;
  public signingLoader: boolean = false;
  public signature: string = '';
  public signature_type: string = '';
  public authenticationTypeEnum = AuthenticationTypeEnum;
  public signingStatusEnum = SigningStatusEnum;
  public attestLoading: boolean = false;
  public assignedSignatureBox: boolean = false;
  public viewDocument:boolean = true;
  private destroyed = new Subject<void>();
  private deletedAttachment:DeletedAttachment[] = [];
  private readonly MOBILE_BREAKPOINT = 911;
  private readonly TEMPLATE_WIDTH_PX = 810;
  @ViewChild('addSignatureSigningModal') public addSignatureSigningModal;
  @ViewChild('modalSignDocument') public modalSignDocument;
  @HostListener('document:keydown', ['$event'])
  @HostListener('document:click', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    const elemenet = event.target as HTMLElement;
    if(!elemenet.matches('.droplist-menu') && !elemenet.matches('.tag-droplist') && !elemenet.matches('.droplist-option-label') && !elemenet.matches('.droplist-arrowDown')){
      document.querySelectorAll('.droplist-dropdown').forEach((element:HTMLElement) => {
        this.renderer.addClass(element, 'hidden');
      });
    }
    const templatePage = elemenet.closest('.template-page');
    if (templatePage) {
      const width = window.outerWidth;
      const templateWidth = 810;

      if (width <= 911) {
        const windowWidth = window.innerWidth;

        // Use RxJS to introduce a small delay before applying the transformation
        this.timeOutSubscription = of(null)
          .pipe(delay(10), take(1))
          .subscribe(() => {
            const templatePageContainer = document.querySelector('.template-page-container');

            if (templatePageContainer) {
              const scaleFactor = windowWidth / templateWidth;

              // Apply the transform to the template-page-container
              this.renderer.setStyle(templatePageContainer, 'transform', `translate3d(0px, 0px, 0px) scale3d(${scaleFactor}, ${scaleFactor}, 1)`);

              // Get the height of the first '.template-page' element and set it
              const templatePageHeight = templatePage.getBoundingClientRect().height;
              this.renderer.setStyle(templatePageContainer, 'height', `${templatePageHeight}px`);
            }
          });
      } else {
        // Remove the styles when the condition doesn't match
        const templatePageContainer = document.querySelector('.template-page-container');
        if (templatePageContainer) {
          this.renderer.removeStyle(templatePageContainer, 'transform');
          this.renderer.removeStyle(templatePageContainer, 'height');
        }
      }
    }
  }
  public globalModalRef: NgbModalRef;
  public templateContent: SafeHtml = '';
  public isMobile = false;
  public roleDetail: RoleDetail;
  public is_sender: number = 0;
  public isPdfView: string;
  toggleSidebar(name): void {
    // this._coreSidebarService.getSidebarRegistry('signing-right-sidebar').isOpened = true;
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
    this.globalService.toggleClass(document.body, 'sidebar-opened');
  }

  async ngOnInit() {
    this.roleId = this.route.snapshot.paramMap.get('id');
    this.globalService.signingAreaRoleId = this.roleId;
    this.isPdfView = this.route.snapshot.paramMap.get('pdfview');
    this.singingPage.getSignDocumentDetail(Number(this.roleId)).subscribe({
      next: async (detail: RoleDetail) => {
        const language = this.globalService.shortLangValue(detail.roleable.language);
        this._translationsHelperService.changeLanguage(language);
        if (detail.roleable.status == this.signingStatusEnum.REVOKED) {
          this.globalService.toastrError(this._translocoService.translate("Toaster error message for revoke document (Signing page - section) - document has been revoked and it can no longer be signed. You do not need to take any further action", {document: detail?.roleable?.visible_name ?? detail?.roleable?.name }));
          return false;
        }
        this.roleDetail = detail;
        if(this.roleDetail?.brand?.title){
          this.titleService.setTitle(this.roleDetail?.brand?.title);
        }
        if(this.roleDetail?.brand?.favicon){
          this._refreshFileService.refreshImage(this.roleDetail?.brand?.favicon, this.roleDetail.id ,0, false).subscribe({
            next : (pdfUrlBlob) => {
              if(pdfUrlBlob){
                const pdfUrl = window.URL.createObjectURL(pdfUrlBlob);
                this.changeFavicon(pdfUrl);
              }
            }
          });
        }
        this.is_sender = detail.recipient_role_detail.is_sender;
        this.roleDetail.recipient = setRecipientData(this.roleDetail.personfields);
        this.templateContent = this.sanitizer.bypassSecurityTrustHtml(detail.roleable.content);
        this.globalService.fields_data = this.roleDetail.roleable.fields_datas?.data ?? {};
        this._sharedStoreFacade$.saveUserTimezone(this.roleDetail?.roleable?.timezone);
      },
      error: (err) => {
        const errorCode = err?.error?.code || err;
        if (errorCode === this.signingStatusEnum.EXPIRED) {
          this.showExpiryExtensionModal(err?.error?.due_date);
        } else {
          this.globalService.toastrError(errorCode);
        }
        this.globalService.toggleClass(document.body, 'sidebar-opened'); 
      },
      complete: () => {
        this.initView(this.globalService.fields_data, this.roleDetail);
      },
    });
    this.editorEmitter.deleteAttachment.pipe(takeUntil(this.destroyed)).subscribe({
      next : (attachment:DeletedAttachment) => {
        this.deletedAttachment = this.deletedAttachment.concat(attachment);
      }
    });

    this.signingHelperService.signatureBase64$.pipe(takeUntil(this.destroyed)).subscribe({
      next: (response) => {
        if(response?.base64signature){
          this.signature = response.base64signature;
          this.signature_type = response.signature_type
        }
      }
    });

    this.loading.pipe(takeUntil(this.destroyed)).subscribe((loading: boolean) => this.attestLoading = loading);
  }

  showExpiryExtensionModal(dueDate: string){
    const expiryModal: NgbModalRef = this.modalService.open(RequestPostponedComponent, {
      size: 'md',
      backdrop: 'static'
    });   
    expiryModal.componentInstance.roleId = this.roleId;
    expiryModal.componentInstance.dueDate = dueDate;
    expiryModal.result.then((result?: {success: false}) => {
      if(result?.success) {
        Swal.fire({
          icon: 'success',
          title: this._translocoService.translate("Toaster success title (Toaster title) - Success"),
          text: this._translocoService.translate("Duedate extension request sent message (Signing Page) - Your request has been sent"),
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          backdrop: true
        });
      }
    })
  }

  changeFavicon(faviconUrl: string): void {
    const link: HTMLLinkElement = this.renderer.createElement('link');
    link.rel = 'icon';
    link.type = 'image/x-icon';
    link.href = faviconUrl;

    // Remove existing favicon if it exists
    const head = document.getElementsByTagName('head')[0];
    const existingFavicon = document.querySelector('link[rel="icon"]');
    if (existingFavicon) {
      head.removeChild(existingFavicon);
    }

    // Append new favicon to the head
    head.appendChild(link);
  }

  /**
   * render the functions
   */
  async initView(fields_data: object, roleDetail: RoleDetail, view: string = 'signingArea') {
    this.isMobile = this.deviceService.isMobile();
    const isLoggedIn = await this.authenticationService.isLoggedIn();
    const userData = this.globalService.userData();
    if(roleDetail.roleable.document_key && (!isLoggedIn || userData?.id != roleDetail.user_id) && !['pdfview','verification'].includes(this.isPdfView)){
      const documentKeyRef:NgbModalRef = this.modalService.open(DocumentKeyComponent, {
        size: 'sm',
        backdrop: 'static'
      });
      documentKeyRef.componentInstance.roleDetail = roleDetail;
      documentKeyRef.result.then((result: {viewdocument:boolean}) => {
        if(result.viewdocument){
          this.viewDocument = true;
          this.loadMethods(fields_data,roleDetail, view);
        }
      }).catch(() => {});
      this.viewDocument = false;
      return;
    }
    this.loadMethods(fields_data,roleDetail, view);
  }





  loadMethods(fields_data: object, roleDetail: RoleDetail, view: string){
    this.timeOutSubscription = of(null).
      pipe(
        delay(400),
        take(1)
      ).subscribe(() => {
        this.signingPageEvent.initEvent(fields_data, roleDetail);
        this.assignedSignatureBox = this.signingPageEvent.isSignatureBox(fields_data, roleDetail);
        if ([this.signingStatusEnum.SENT, this.signingStatusEnum.DELIVERED, this.signingStatusEnum.VIEWED].includes(roleDetail.recipient_role_detail.status)) {
          const isReadOnly = roleDetail.authentication_type === this.authenticationTypeEnum.READONLY;
          const isBankId = roleDetail.authentication_type === this.authenticationTypeEnum.BANKID;
          if(isReadOnly){
            this.singingPage.readOnly(roleDetail.id).pipe(take(1)).subscribe();
          }
          if(isBankId && this.globalService.isSamsungBrowser()){
            this.modalService.open(SamsungBrowserInstructionsModalComponent);
          }
        }

        // Post-sign modal has been completely removed from platform
        // Refresh expire files url on document
        if(view !== 'fullScreenView'){
          this._refreshFileService.refreshDocumentFiles(this.globalService.fields_data, roleDetail?.id, 0, false, roleDetail?.brand);
        } else {
          const isOwner = ([SigningStatusEnum.DRAFT].includes((roleDetail?.roleable?.status as SigningStatusEnum)) || roleDetail?.roleable?.type === TemplateType.TEMPLATEDOCUMENT);
          this.refreshImageService.collectTheImagesOfTemplate('document', roleDetail?.roleable_id, roleDetail?.brand, isOwner);
        }
        if (this.isMobile) {
          if(this._coreSidebarService.getSidebarRegistry('signing-right-sidebar')){
            this._coreSidebarService.getSidebarRegistry('signing-right-sidebar').isOpened = true;
            this._coreSidebarService.getSidebarRegistry('signing-right-sidebar').close();
          }
          this.renderer.removeClass(document.body, 'sidebar-opened');
        } else {
          if (!['pdfview','verification'].includes(this.isPdfView)) {
            if(this._coreSidebarService.getSidebarRegistry('signing-right-sidebar')){
              this._coreSidebarService.getSidebarRegistry('signing-right-sidebar').isOpened = true;
            }
            this.renderer.addClass(document.body, 'sidebar-opened');
          }
        }
        this.loadingSigningArea = false;
        if(this.isPdfView){
          this.hideUnusedBlocksService.hideUnusedBlocks();
        }
         this.makePageResponsive();
      })
  }


  updateStylePropertyOfTag(removeStyle:boolean, uuid, color:string=''){
    const fieldElement = document.querySelector('.drag-fields[uuid="' + uuid + '"]');
    const tagElement = fieldElement?.querySelector('.tag-container');
    if(tagElement){
      const textTag = tagElement?.querySelector('.selected-label') as HTMLElement;
      if(textTag){
        if(removeStyle){
          this.renderer.removeStyle(textTag, 'color');
        }else{
          this.renderer.setStyle(textTag, 'color', color);
        }
      }
    }
  }

  closeModal(action: string) {
    this.globalModalRef.close(action);
  }

  ngOnDestroy() {
    if (this.timeOutSubscription) {
      this.timeOutSubscription.unsubscribe();
    }
  }

  modalAfterSignDocumentOpen(modalAfterSignDocument) {
    this.modalService.open(modalAfterSignDocument, {
      size: 'lg',
      windowClass: 'afterSign-document-modal',
      backdrop: 'static'
    });

    this.signingDocFlowTwo = false;
    this.signingDocFlowOne = true;
  }

  signingDocumentFlow() {
    this.signingDocFlowOne = false;
    this.signingDocFlowTwo = true;
  }

  signingDocumentFlowBack() {
    this.signingDocFlowTwo = false;
    this.signingDocFlowOne = true;
  }

  /**
   * when recipient read and understood
   */
  agree() {
    this.iAgreed = !this.iAgreed;
  }

  /**
   * validate and signing process
   */
  async validateTheSigningProgress() {
    const { status } = fieldsValidation(this.globalService.fields_data, this.globalService, String(this.roleDetail.id), this.roleDetail.last_recipient);
    if (status) {
      if(!this.assignedSignatureBox && this.roleDetail?.company?.finger_sign === 1){
        this.signingHelperService.setCall({ assignedSignatureBox: this.assignedSignatureBox });
        const { signature, signature_type } = await lastValueFrom(this.signingHelperService.signatureBase64$.pipe(take(1)));
        this.signature = signature;
        this.signature_type = signature_type;
      }
      if ((typeof this.signature == 'undefined' || this.signature == "") && (this.assignedSignatureBox || this.roleDetail?.company?.finger_sign === 1)) {
        this.globalService.toastrWarning(this._translocoService.translate("Toaster warning message for signer (Signing page - section) - Signature is required"));
        return;
      }
      const afterSign: NgbModalRef = this.modalService.open(SignDocumentModalComponent, {
        windowClass: 'sign-document-modal',
        backdrop: 'static'
      });
      afterSign.result.then(() => {

      });
      afterSign.componentInstance.fields_data = this.globalService.fields_data;
      afterSign.componentInstance.signature = this.signature;
      afterSign.componentInstance.signature_type = this.signature_type;
      afterSign.componentInstance.roleId = this.roleId;
      afterSign.componentInstance.roleDetail = this.roleDetail;
      afterSign.componentInstance.deleted_attachments = this.deletedAttachment;
      afterSign.componentInstance.document_name = this.roleDetail?.roleable?.visible_name ?? this.roleDetail?.roleable.name;
      afterSign.componentInstance.recipientName = this.roleDetail.recipient.firstname +" "+ (this.roleDetail.recipient?.lastname ?? "");
    }
  }

  /**
   * attest the document
   */
  async attestTheDocument() {
    const { status } = fieldsValidation(this.globalService.fields_data, this.globalService, String(this.roleDetail.id), this.roleDetail.last_recipient);
    if (status) {
      this.attestLoading = true;
      this.signTheDocument(this.roleDetail.id, '', '', null, this.roleDetail, this.deletedAttachment, this.globalService.fields_data);
    }
  }

  makePageResponsive(){
    const templatePageContainer = document.querySelector('.template-main-container');
    if(templatePageContainer){
        if (window.outerWidth <= this.MOBILE_BREAKPOINT) {
            const totalWidth = window.innerWidth;
            const contentWidth = document.documentElement.clientWidth;
            const scrollbarWidth = totalWidth - contentWidth;
            const adjustedWidth = totalWidth - scrollbarWidth;
            const width = adjustedWidth;
            const templateWidth = this.TEMPLATE_WIDTH_PX;
            this.renderer.setStyle(templatePageContainer, 'transform', `translate3d(0px, 0px, 0px) scale3d(${(width / templateWidth)}, ${(width / templateWidth)}, 1)`);
            const templatePageHeight = document.querySelector('.template-page').getBoundingClientRect().height;
            this.renderer.setStyle(templatePageContainer, 'height', `${templatePageHeight}px`);
        } else {
            this.renderer.setStyle(templatePageContainer, 'height', ``);
            this.renderer.setStyle(templatePageContainer, 'transform', ``);
        }
    }
  }

}
